import { render, staticRenderFns } from "./StepsView.vue?vue&type=template&id=3118b279&lang=true&"
import script from "./StepsView.vue?vue&type=script&lang=js&"
export * from "./StepsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports